import React from 'react';
import { connect } from 'react-redux';

import withStyles from '@mui/styles/withStyles';

import { setApiResponseInfo } from '../store/slices/apiResponseInfoSlice';

import { apiFetch, createStdRequest } from '../utils/utils';

import DA from '../store/ReduxAccess';
import ReduxLoader from '../store/ReduxLoader';

import activityPanelStyles from '../assets/jss/crm/components/activityPanelStyles';

import ConfirmModal from './ConfirmModal';
import CrmTextField from './CrmTextField';
import CrmButton from './CrmButton';

/*
Call with
<NoteEditorPanel
  noteId={<id of existing note>}
  page={somebody that implements buildActivityGroupsFromReduxStore()}
  noteDeletionFunc={function} // to delete the note and close the modal.
  closeEditorFunc={function}
/>
*/

class NoteEditorPanel extends React.Component {
  state = {
    noteText: '',
  };

  componentDidMount() {
    const noteId = this.props.noteId;
    const note = DA.getNoteWithId(noteId);
    this.setState({ noteText: note.content });
  }

  componentDidUpdate(prevProps) {
    const noteId = this.props.noteId;
    if (prevProps.noteId !== noteId) {
      const note = DA.getNoteWithId(noteId);
      this.setState({ noteText: note.content });
    }
  }

  handleNoteTextChange(newVal) {
    this.setState({ noteText: newVal });
  }

  offerToDeleteNote() {
    const q = 'Are you sure you want to delete this note?';
    this.setState({
      shouldShowDeletionConfirmationModal: true,
      deletionConfirmationQuery: q,
      deleteFunc: () => this.props.noteDeletionFunc(),
    });
  }

  updateNote() {
    const uri = `/api/note/${this.props.noteId}`;
    const apiStruct = this.createNoteApiStruct();
    const request = createStdRequest(uri, 'PUT', apiStruct);
    const actionOnGoodResponse = (json) => {
      // update Redux store
      const contactId = json.subjectId;
      ReduxLoader.addOrUpdateNotesOnPersons([json]);
      this.props.page.buildActivityGroupsFromReduxStore(contactId);
      this.props.closeEditorFunc();
    };
    apiFetch(this, request, actionOnGoodResponse);
  }

  createNoteApiStruct() {
    const note = DA.getNoteWithId(this.props.noteId);
    const date = note.date.toISO();
    const authorEmail = this.props.userInfo.email;
    const viewingFirmId = DA.getFirmId();
    const referrerOrgId = note.otherFirmId;
    const contactId = note.subjectId;
    return {
      noteId: note.noteId,
      date,
      authorEmail,
      viewingFirmId,
      otherFirmId: referrerOrgId,
      subjectId: contactId,
      content: this.state.noteText.trim(),
    };
  }

  render() {
    const { classes } = this.props;
    return (
      <div>
        <ConfirmModal
          show={this.state.shouldShowDeletionConfirmationModal}
          title="Confirm Deletion"
          confirmButtonLabel="Delete"
          rejectButtonLabel="Cancel"
          onConfirm={this.state.deleteFunc}
          onReject={() => this.setState({ shouldShowDeletionConfirmationModal: false })}
        >
          <div>{this.state.deletionConfirmationQuery}</div>
        </ConfirmModal>

        <div className={classes.activityPanel_content}>
          <CrmTextField
            label="Type note here"
            fullWidth
            multiline
            value={this.state.noteText}
            onChange={(event) => this.handleNoteTextChange(event.target.value)}
          />
        </div>
        {this.state.noteText.trim().length > 0 && (
          <div className={classes.u_alignRight}>
            <CrmButton outlined size="small" onClick={() => this.offerToDeleteNote()}>
              Delete
            </CrmButton>
            <CrmButton outlined size="small" onClick={() => this.props.closeEditorFunc()}>
              Cancel
            </CrmButton>
            <CrmButton filled size="small" onClick={() => this.updateNote()}>
              Save
            </CrmButton>
          </div>
        )}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  userInfo: state.userInfo,
});

const actionProducers = {
  setApiResponseInfo,
};

export default connect(mapStateToProps, actionProducers)(withStyles(activityPanelStyles)(NoteEditorPanel));
